import { Injectable } from '@angular/core';
import { Http, Response, Headers, RequestOptions } from '@angular/http';
import { ConfigService } from '../config/config-service';
import { SessionService } from './session.service';
import { Options } from 'selenium-webdriver/firefox';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map';

@Injectable()
export class UsuarioRestriccionService{
    private config: ConfigService;
    private _token: any;
    private host_api: String;
    private dbname: string;

    constructor(private http: Http, private ss: SessionService){
        this.config =  new ConfigService();
        this.host_api = this.ss.getData('host_api');
        this._token = sessionStorage.getItem('api-token');
        this.dbname = this.ss.getData('dbname');
    }

    save(usuario_restriccion){
        let url = this.host_api + '/usuarios/restricciones';
        let params = usuario_restriccion;
        let headers = new Headers({'Content-type': 'application/json'});
        headers.append('Authorization', "Bearer " + this._token);
        headers.append('dbname', this.dbname);

        let options = new RequestOptions({ headers: headers});

        return this.http.post(url, params, options).map((res: Response) => {
            return this.config.onSuccessResponse(res);
        }).catch((error: any) => {
            return this.config.onErrorResponse(error);
        });
    }

    update(usuario_id_restriccion){
        let url = this.host_api + '/usuarios/restricciones/'+usuario_id_restriccion;
        let params = usuario_id_restriccion;
        let headers = new Headers({'Content-type': 'application/json'});
        headers.append('Authorization', "Bearer " + this._token);
        headers.append('dbname', this.dbname);

        let options = new RequestOptions({ headers: headers});

        return this.http.put(url, params, options).map((res:Response) => {
            return this.config.onSuccessResponse(res);
        }).catch((error: any) => {
            return this.config.onErrorResponse(error);
        });
    }
}


// WEBPACK FOOTER //
// /var/www/nodejs/nextstore/src/app/services/usuario-restriccion.service.ts